(function () {

  // ❌ Do NOT translate if user is on /en pages
  if (window.location.pathname.startsWith('/en')) return;

  const map = {
    "Spin to win": "Griez un laimē",
    "Spin & Save BIG!":"Iegriez ratu un pārbaudi savu veiksmi!",
    "Enter your full name and email to spin the wheel for a chance to win": "Ievadiet savu pilnu vārdu un e-pasta adresi, lai grieztu ratu un iegūtu iespēju laimēt.",
    "I agree to my personal data being stored and used to receive the newsletter": "Es piekrītu, ka mani personas dati tiek glabāti un izmantoti, lai saņemtu jaunumus",
    "YOU WON! CONGRATS!": "TU LAIMĒJI! APSVEICAM!",
    "Don't forget to copy your coupon code before closing.":
    "Neaizmirsti nokopēt atlaides kodu pirms aizvēršanas.",
    "Copy": "Kopēt",
    "Copied": "Nokopēts",
    "Try Your Luck!": "Izmēģini veiksmi!",
    "Free shipping": "Bezmaksas piegāde",
    "Better Luck for Next Time!": "Nākamreiz paveiksies!",
    "Sorry": "Diemžēl ne šoreiz",
    "So Close": "Tik tuvu ",
    "Almost Near": "Ļoti tuvu",
    "No luck today": "Šodien nepaveicās",
    "5% OFF":"5% ATLAIDE",
    "7% OFF": "7% ATLAIDE",
    "10% OFF": "10% ATLAIDE",
    "3% OFF": "3% ATLAIDE"

  };

  function translateNode(node) {
    // Translate text nodes only
    if (node.nodeType === Node.TEXT_NODE) {
      const trimmed = node.textContent.trim();
      if (map[trimmed]) {
        node.textContent = node.textContent.replace(trimmed, map[trimmed]);
      }
    }

    // Recursively translate children
    if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(child => translateNode(child));
    }
  }

  function translateWheelify() {
    const wheel = document.querySelector('#wheelify');
    if (!wheel) return;
    translateNode(wheel);
  }

  // Initial translation attempt
  translateWheelify();

  // Observe DOM changes (Wheelify loads dynamically)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.id === 'wheelify' || node.querySelector('#wheelify')) {
            translateWheelify();
          } else {
            translateNode(node);
          }
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

